<template>
    <div class="text-center">
        <v-bottom-sheet
            v-model="sheetShown"
            persistent
            scrollable
            :fullscreen="$vuetify.breakpoint.mobile"
            :inset="!$isSmallDesktop()"
            class="flex flex-direction: column;"
            :class="{smallDisplay: $isSmallDesktop()}"
            content-class="slotmanagement_bottomSheet">
            <v-card>
                <!-- >>> Selected Flight List -->
                <!-- <sdr-selected-flight-list
                    :filtered_selectedFlights="selectedSlots"
                    :preSelectedSlots="preSelectedSlots"
                    v-bind="{ onAssign_Update: onAssign_Update }"
                    :editorMode="editorMode"
                    :smallScreen="$isSmallDesktop()"
                    :openId="openId"
                    :selectedLayer="selectedLayer" /> -->
                <!-- <<< Selected Flight List -->

                <!-- >>> Stepper (Dynamic) -->
                <v-card-text class="mt-3" style="height:800px;width:100%;">
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-container style="padding:10px 30px !important;max-width: 100%">
                            <v-stepper v-model="formStepper" style="overflow:visible;position:relative;" non-linear>
                                <sdr-stepper-header
                                        :editorMode="editorMode"
                                        :validations="validation"
                                        :validationSelectedFlights="validationSelectedFlights"
                                        :onClick_StepperHeader="onClick_StepperHeader" />

                                    <!-- >>> Stepper: 1 - 'Flight Config'        -->
                                    <v-stepper-content ref="stepperContent1" class="pt-3" step="1">
                                        <!-- >>> Single View -->
                                        <v-row v-if="editorFlightLegMode === 'single'" class="input-row">
                                            <v-col class="pt-0" cols="12" sm="12">
                                                <sdr-step1-slotconfig
                                                    :editorMode="editorMode"
                                                    :editorFlightLegMode="editorFlightLegMode"
                                                    :data="crudData"
                                                    :showDeleteCheckbox="editMultipleFlights"
                                                    leg="firstLeg"
                                                    :rules="rules" />
                                            </v-col>
                                        </v-row>
                                        <!-- <<< Single View -->
                                        <!-- >>> Rotation View -->
                                        <v-row v-if="editorFlightLegMode === 'rotation'" class="input-row">
                                            <v-col cols="12" sm="5">
                                                <sdr-step1-slotconfig
                                                    :editorMode="editorMode"
                                                    :editorFlightLegMode="editorFlightLegMode"
                                                    :showDeleteCheckbox="editMultipleFlights"
                                                    :data="crudData"
                                                    leg="firstLeg"
                                                    :rules="rules" />
                                            </v-col>

                                            <v-col class="py-0" style="display:flex;justify-content:center;" cols="12" sm="2">
                                                <div style="height:100%;width:1px;background:#ccc;" />
                                            </v-col>

                                            <v-col cols="12" sm="5">
                                                <sdr-step1-slotconfig
                                                    :editorMode="editorMode"
                                                    :editorFlightLegMode="editorFlightLegMode"
                                                    :showDeleteCheckbox="editMultipleFlights"
                                                    :data="crudData"
                                                    leg="secondLeg"
                                                    :rules="rules" />
                                            </v-col>
                                        </v-row>
                                        <!-- <<< Rotation View -->
                                    </v-stepper-content>
                                    <!-- <<< Stepper: 1 - 'Flight Config'        -->

                                    <!-- >>> Stepper: 1 - 'Flight Period'        -->
                                    <v-stepper-content ref="stepperContent2" class="pt-3" step="2">
                                        <v-row class="input-row">
                                            <v-col class="pt-0" cols="12" sm="12">
                                                <sdr-step2-slotperiod
                                                    :editorMode="editorMode"
                                                    :editorFlightLegMode="editorFlightLegMode"
                                                    :data="crudData"
                                                    :showDeleteCheckbox="editMultipleFlights"
                                                    leg="firstLeg"
                                                    :rules="rules"
                                                    :onChange_TabChange="onChange_TabChange" />
                                            </v-col>
                                        </v-row>
                                    </v-stepper-content>
                                    <!-- <<< Stepper: 1 - 'Flight Period'        -->
                                </v-stepper>
                        </v-container>
                    </v-form>
                </v-card-text>
                <!-- <<< Stepper (Dynamic) -->

                <sdr-stepper-action-bar
                    editorMode="update"
                    :counter="selectedSlots.length"
                    :editorFlightLegMode="editorFlightLegMode"
                    @close="onClick_CloseSheet"
                    @save="onValidate_Form" />
            </v-card>
        </v-bottom-sheet>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { mapGetters } from 'vuex';
    import { eventBus } from '../../../../../../../main';
    import dayjs from 'dayjs';

    import BottomSheet from './BottomSheet.vue';
    import SelectedFlightList from './SelectedFlightList.vue';


    export default {
        name: 'BottomSheetUpdate',


        /* >>> *************************************************************** / /* Components */
		components: {

            'sdr-selected-flight-list': SelectedFlightList

		},
        extends: BottomSheet, // eo components{}
		/* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Props */
        props: {

            selectedSlots: Array,
            selectedLayer: Number,  // 1 Chain, 2 Rotation, 3 Leg
            editorMode: String,
            editorFlightLegMode: String

        }, // eo props{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                // >>> -----
                deleteInformations: {
                    firstLeg: [],
                    secondLeg: []
                },
                // >>> -----
                validationSelectedFlights: {},
                // >>> -----
                filtered_selectedFlights: [],
                preSelectedSlots: [],
                emitted_selectedSlots: [],
                flightLegMode: '',
                flightTypeTab: {
                    firstLeg: 0,
                    secondLeg: 0
                },
                openId: []
            };

        }, // eo data{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_flights_Events',
                'get_similarFlights',
                'get_Airports',
                'get_flights_OCCMode',
                'get_FlightTable_Rotations_Chain_Filtered'
            ]),


            /*******************************************************************
            * editMultipleFlights
            *
            * Desc: Flag: true if user wants to update more than 1 flight.
            * Note:
            *
            */
            editMultipleFlights: {

                get() {

                    const me = this;


                    me.$toc('>>> views/shared/components/BottomSheetUpdate.vue >>> computed/editMultipleFlights/get');
                    return me.emitted_selectedSlots.length > 1;

                } // eo funciton get()

            } // eo function editMultipleFlights()

        }, // eo computed{}
        /* <<< ****************************************************************/



        /********************************************************************** / /* Watch */
    watch: {

        /***********************************************************************
        * sheetShown
        *
        * Desc:
        * Note:
        *
        */
        sheetShown(val) {

                const me = this;

                if (me.editorMode === 'create' && val === true) {
                    me.onAssign_Create();
                }
        } // eo function sheetShown()

    }, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function() {

            const me = this;


            me.$toc('>>> views/shared/components/BottomSheetUpdate.vue >>> created');
            eventBus.$on('flightswasupdated', me.onEmit_FlightWasUpdated);
            eventBus.$on('markToDeleteBus', me.onMarkToDelete_setDeleteInformations);
            eventBus.$on('rotationsselected', me.onEmit_rotationsSelected);
            me.onCreate_initialUpdateConfig();

		}, // eo function created()
		/* <<< ****************************************************************/


        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
		destroyed: function() {

            const me = this;


            me.$toc('>>> views/shared/components/BottomSheetUpdate.vue >>> destroyed');
            eventBus.$off('flightswasupdated', this.onEmit_FlightWasUpdated);
            eventBus.$off('markToDeleteBus', this.onMarkToDelete_setDeleteInformations);
            eventBus.$off('rotationsselected', me.onEmit_rotationsSelected);

		}, // eo function destroyed()
        /* <<< *************************************************************** /



        /* >>> ***************************************************************** / /* Methods */
        methods: {

            //-----------------------------------------------------------------/
            // #
            // #    /$$$$$$                                                   /$$
            // #   /$$__  $$                                                 | $$
            // #  | $$  \__/  /$$$$$$  /$$$$$$$   /$$$$$$   /$$$$$$  /$$$$$$ | $$
            // #  | $$ /$$$$ /$$__  $$| $$__  $$ /$$__  $$ /$$__  $$|____  $$| $$
            // #  | $$|_  $$| $$$$$$$$| $$  \ $$| $$$$$$$$| $$  \__/ /$$$$$$$| $$
            // #  | $$  \ $$| $$_____/| $$  | $$| $$_____/| $$      /$$__  $$| $$
            // #  |  $$$$$$/|  $$$$$$$| $$  | $$|  $$$$$$$| $$     |  $$$$$$$| $$
            // #   \______/  \_______/|__/  |__/ \_______/|__/      \_______/|__/
            // #
            //-----------------------------------------------------------------/
            /*******************************************************************
            * onCreate_initialUpdateConfig()
            *
            * Desc:
            * Note:
            *
            */
            onCreate_initialUpdateConfig: function () {

                const me = this;


                me.$toc('>>> views/shared/components/BottomSheetUpdate.vue >>> onCreate_initialUpdateConfig');
                if (me.selectedLayer === 1) {

                    me.preSelectedSlots = me.selectedSlots[0].children;
                    me.openId = [me.selectedSlots[0].id];

                } else {
                    me.preSelectedSlots = me.selectedSlots;

                }
            }, // eo function onCreate_initialUpdateConfig()


            /*******************************************************************
            * onEmit_FlightWasUpdated()
            *
            * Desc:
            * Note:
            *
            */
            onEmit_FlightWasUpdated: function() {

                const me = this;


                me.$toc('>>> views/shared/components/BottomSheetUpdate.vue >>> onEmit_FlightWasUpdated');
                // >>> ----- reset
                me.deleteInformations = {
                    firstLeg: [],
                    secondLeg: []
                };

            }, // eo function onEmit_FlightWasUpdated()


            /*******************************************************************
            * onMarkToDelete_setDeleteInformations()
            *
            * Desc: Resets the rules state on tab change. (Step2RouteConfig + Step3RouteConfig)
            * Note:
            *
            */
            onMarkToDelete_setDeleteInformations: function(v) {

                const me = this;


                me.$toc('>>> views/shared/components/BottomSheetUpdate.vue >>> onMarkToDelete_setDeleteInformations');
                if (v.value === true) {
                    me.deleteInformations[v.leg].push(v.type);
                } else {
                    me.deleteInformations[v.leg] = me.deleteInformations[v.leg].filter(d => d !== v.type);
                }

            }, // eo function onMarkToDelete_setDeleteInformations()

            /*******************************************************************
            * onEmit_rotationsSelected()
            *
            * Desc:
            * Note:
            *
            */
            onEmit_rotationsSelected: function (slots) {

                const me = this;

                me.$toc('>>> views/shared/components/BottomSheetUpdate.vue >>> onEmit_rotationsSelected');
                if (slots.length > 0) {
                    me.emitted_selectedSlots = slots;
                    me.flightLegMode = slots[0].isRotation ? 'rotation' : 'single'; // TODO:
                    me.onAssign_Update(me.buildFlightObjectFromCombinedFlights(slots));
                } else {
                    me.onAssign_Reset();
                }

            }, // eo function onEmit_rotationsSelected()


            // #    /$$$$$$  /$$$$$$$  /$$$$$$$$  /$$$$$$  /$$$$$$$$/$$$$$$$$
            // #   /$$__  $$| $$__  $$| $$_____/ /$$__  $$|__  $$__/ $$_____/
            // #  | $$  \__/| $$  \ $$| $$      | $$  \ $$   | $$  | $$
            // #  | $$      | $$$$$$$/| $$$$$   | $$$$$$$$   | $$  | $$$$$
            // #  | $$      | $$__  $$| $$__/   | $$__  $$   | $$  | $$__/
            // #  | $$    $$| $$  \ $$| $$      | $$  | $$   | $$  | $$
            // #  |  $$$$$$/| $$  | $$| $$$$$$$$| $$  | $$   | $$  | $$$$$$$$
            // #   \______/ |__/  |__/|________/|__/  |__/   |__/  |________/
            // #
            // #
            // #
            /*******************************************************************
            * createSlotPayload()
            *
            * Desc:
            * Note:
            *
            */
            createSlotPayload: function () {

                const me = this,
                    slots = [];

                me.crudData.firstLeg.input_datesInRange.dates.forEach(date => {
                    const firstLeg = me.crudData.firstLeg;
                    slots.push({
                        aircraftType: firstLeg.input_AircraftConfig,
                        airport: firstLeg.input_Airport.aptCode,
                        airportSlot: firstLeg.input_AirportSlot.aptCode,
                        direction: firstLeg.input_Direction,
                        flightNo: firstLeg.input_FlightNo,
                        flightType: 'D', // TODO: VIA / TRIA?
                        fromDate: null, //dayjs(firstLeg.input_FromDate).format('YYYY-MM-DDT00:00:00[Z]'),
                        mainServiceType: firstLeg.input_MainServiceType,
                        slotTime: dayjs(date).format('YYYY-MM-DDT') + dayjs().format(`${firstLeg.input_Slot_Time}:00[Z]`),
                        status: 'DUMMY',
                        toDate: null //dayjs(firstLeg.input_ToDate).format('YYYY-MM-DDT00:00:00[Z]')
                    });

                    if (me.editorFlightLegMode === 'rotation') {
                        const secondLeg = me.crudData.secondLeg;
                        slots.push({
                            aircraftType: secondLeg.input_AircraftConfig,
                            airportSlot: secondLeg.input_AirportSlot.aptCode,
                            airport: secondLeg.input_Airport.aptCode,
                            direction: secondLeg.input_Direction,
                            flightNo: secondLeg.input_FlightNo,
                            flightType: 'D', // TODO: VIA / TRIA?
                            fromDate: null, //firstLeg.input_FromDate,
                            mainServiceType: secondLeg.input_MainServiceType,
                            slotTime: dayjs(date).format('YYYY-MM-DDT') + dayjs().format(`${secondLeg.input_Slot_Time}:00[Z]`),
                            status: 'DUMMY',
                            toDate: null //firstLeg.input_ToDate
                        });
                    }
                });
                return { slots: slots };
            }, // eo function createSlotPayload()


            //-----------------------------------------------------------------/
            // #
            // #  /$$   /$$                 /$$             /$$
            // # | $$  | $$                | $$            | $$
            // # | $$  | $$  /$$$$$$   /$$$$$$$  /$$$$$$  /$$$$$$    /$$$$$$
            // # | $$  | $$ /$$__  $$ /$$__  $$ |____  $$|_  $$_/   /$$__  $$
            // # | $$  | $$| $$  \ $$| $$  | $$  /$$$$$$$  | $$    | $$$$$$$$
            // # | $$  | $$| $$  | $$| $$  | $$ /$$__  $$  | $$ /$$| $$_____/
            // # |  $$$$$$/| $$$$$$$/|  $$$$$$$|  $$$$$$$  |  $$$$/|  $$$$$$$
            // #  \______/ | $$____/  \_______/ \_______/   \___/   \_______/
            // #           | $$
            // #           | $$
            // #           |__/
            // #
            //-----------------------------------------------------------------/
            /*******************************************************************
            * createUpdateFlightsPayload
            *
            * Desc:
            * Note:
            *
            */
            createUpdateFlightsPayload: function() {

                const me = this,
                    flightsToUpdate = me.emitted_selectedSlots,
                    payload = [];
                let legs;


                me.$toc('>>> views/shared/components/BottomSheetUpdate.vue >>> createUpdateFlightsPayload');
                // TODO: put into config.js (needs to stay globally updated)
                const flightObjectFields = [
                    // 1 Flight Config
                    {
                        inputName: 'input_AircraftConfig',
                        backendEmptyState: null,
                        legInfoName: 'idAircraftConfig',
                        deleteInformationsName: 'AIRCRAFTCONFIGURATION'
                    },
                    {   // future feature
                        inputName: 'input_MainServiceType',
                        backendEmptyState: 'C',
                        legInfoName: 'mainServiceType',
                        deleteInformationsName: 'mainServiceType'
                    },
                    {
                        inputName: 'input_CodeShare',
                        backendEmptyState: null,
                        legInfoName: 'codeshare',
                        deleteInformationsName: 'CODE_SHARE'
                    },
                    {
                        inputName: 'input_Range',
                        backendEmptyState: 'SHORT',
                        legInfoName: 'routeLength',
                        deleteInformationsName: 'RANGE'
                    },
                    {
                        inputName: 'input_PermissionNumber',
                        backendEmptyState: '',
                        legInfoName: 'permissionNumber',
                        deleteInformationsName: 'PERMISSION_NUMBER'
                    },
                    {
                        inputName: 'input_ServiceFlags',
                        backendEmptyState: [],
                        legInfoName: 'serviceFlags',
                        deleteInformationsName: 'SERVICE_FLAGS'
                    },
                    {
                        inputName: 'input_FlightComment',
                        backendEmptyState: null,
                        legInfoName: 'flightComment',
                        deleteInformationsName: 'FLIGHTCOMMENT'
                    },
                    {
                        inputName: 'input_Comment',
                        backendEmptyState: null,
                        legInfoName: 'comment',
                        deleteInformationsName: 'COMMENT'
                    },
                    {   // gets detected automatically in backend. no "real" input
                        inputName: 'input_flightModus',
                        backendEmptyState: null,
                        legInfoName: 'flightModus',
                        deleteInformationsName: 'FLIGHTMODUS'
                    },
                    // 2 Date
                    {
                        inputName: 'input_dates_dates',
                        backendEmptyState: null,
                        legInfoName: 'dates',
                        deleteInformationsName: 'DATE'
                    },
                    // 2 Route Config
                    // DIRECT --------------------------------------------------
                    {
                        inputName: 'input_directFlight_FlightNo',
                        type: 'D',
                        name: 'AB',
                        backendEmptyState: null,
                        legInfoName: 'flightNo',
                        deleteInformationsName: 'FLIGHTNO'
                    },
                    {
                        inputName: 'input_directFlight_AtcCallSign',
                        type: 'D',
                        name: 'AB',
                        backendEmptyState: null,
                        legInfoName: 'atcCallSign',
                        deleteInformationsName: 'ATC_CALL_SIGN'
                    },
                    {
                        inputName: 'input_directFlight_AirportDeparture',
                        type: 'D',
                        name: 'AB',
                        backendEmptyState: null,
                        legInfoName: 'aptFrom',
                        deleteInformationsName: 'AB_AIRPORTDEPARTURE'
                    },
                    {
                        inputName: 'input_directFlight_AirportDestination',
                        type: 'D',
                        name: 'AB',
                        backendEmptyState: null,
                        legInfoName: 'aptTo',
                        deleteInformationsName: 'AB_AIRPORTDESTINATION'
                    },
                    // VIA -----------------------------------------------------
                    {
                        inputName: 'input_viaFlight_FlightNo',
                        type: 'V',
                        backendEmptyState: null,
                        legInfoName: 'flightNo',
                        deleteInformationsName: 'FLIGHTNO'
                    },
                    {
                        inputName: 'input_viaFlight_AtcCallSign',
                        type: 'V',
                        backendEmptyState: null,
                        legInfoName: 'atcCallSign',
                        deleteInformationsName: 'ATC_CALL_SIGN'
                    },
                    {
                        inputName: 'input_viaFlight_AirportDeparture',
                        type: 'V',
                        name: 'AB',
                        backendEmptyState: null,
                        legInfoName: 'aptFrom',
                        deleteInformationsName: 'AB_AIRPORTDEPARTURE'
                    },
                    {
                        inputName: 'input_viaFlight_AirportVia',
                        type: 'V',
                        name: 'AB',
                        backendEmptyState: null,
                        legInfoName: 'aptTo',
                        deleteInformationsName: 'AB_AIRPORTDEPARTURE'
                    },
                    {
                        inputName: 'input_viaFlight_AirportVia',
                        type: 'V',
                        name: 'BC',
                        backendEmptyState: null,
                        legInfoName: 'aptFrom',
                        deleteInformationsName: 'AB_AIRPORTDESTINATION'
                    },
                    {
                        inputName: 'input_viaFlight_AirportDestination',
                        type: 'V',
                        name: 'BC',
                        backendEmptyState: null,
                        legInfoName: 'aptTo',
                        deleteInformationsName: 'AB_AIRPORTDEPARTURE'
                    },
                    // TRIA ----------------------------------------------------
                    {
                        inputName: 'input_triaFlight_FlightNo',
                        type: 'T',
                        backendEmptyState: null,
                        legInfoName: 'flightNo',
                        deleteInformationsName: 'FLIGHTNO'
                    },
                    {
                        inputName: 'input_triaFlight_AtcCallSign',
                        type: 'T',
                        backendEmptyState: null,
                        legInfoName: 'atcCallSign',
                        deleteInformationsName: 'ATC_CALL_SIGN'
                    },
                    {
                        inputName: 'input_triaFlight_FlightNoVia',
                        type: 'T',
                        name: 'CA',
                        backendEmptyState: null,
                        legInfoName: 'flightNo',
                        deleteInformationsName: 'FLIGHTNOVIA'
                    },
                    {
                        inputName: 'input_triaFlight_AtcCallSignVia',
                        type: 'T',
                        name: 'CA',
                        backendEmptyState: null,
                        legInfoName: 'atcCallSign',
                        deleteInformationsName: 'ATC_CALL_SIGNVIA'
                    },
                    {
                        inputName: 'input_triaFlight_AirportDestinationDeparture',
                        type: 'T',
                        name: 'AB',
                        backendEmptyState: null,
                        legInfoName: 'aptFrom',
                        deleteInformationsName: 'AB_AIRPORTDEPARTURE'
                    },
                    {
                        inputName: 'input_triaFlight_AirportFirstVia',
                        type: 'T',
                        name: 'AB',
                        backendEmptyState: null,
                        legInfoName: 'aptTo',
                        deleteInformationsName: 'AB_AIRPORTDEPARTURE'
                    },
                    {
                        inputName: 'input_triaFlight_AirportFirstVia',
                        type: 'T',
                        name: 'BC',
                        backendEmptyState: null,
                        legInfoName: 'aptFrom',
                        deleteInformationsName: 'AB_AIRPORTDEPARTURE'
                    },
                    {
                        inputName: 'input_triaFlight_AirportSecondVia',
                        type: 'T',
                        name: 'BC',
                        backendEmptyState: null,
                        legInfoName: 'aptTo',
                        deleteInformationsName: 'AB_AIRPORTDEPARTURE'
                    },
                    {
                        inputName: 'input_triaFlight_AirportSecondVia',
                        type: 'T',
                        name: 'CA',
                        backendEmptyState: null,
                        legInfoName: 'aptFrom',
                        deleteInformationsName: 'AB_AIRPORTDEPARTURE'
                    },
                    {
                        inputName: 'input_triaFlight_AirportDestinationDeparture',
                        type: 'T',
                        name: 'CA',
                        backendEmptyState: null,
                        legInfoName: 'aptTo',
                        deleteInformationsName: 'AB_AIRPORTDEPARTURE'
                    },
                    // DIRECT/VIA/TRIA -----------------------------------------
                    {
                        inputName: 'input_AB_Time_Departure_Scheduled',
                        name: 'AB',
                        backendEmptyState: null,
                        format: 'time',
                        legInfoName: 'dep_sch_time',
                        deleteInformationsName: 'AB_SCHEDULED_DEPARTURE'
                    },
                    {
                        inputName: 'input_AB_Time_Arrival_Scheduled',
                        name: 'AB',
                        backendEmptyState: null,
                        format: 'time',
                        legInfoName: 'arr_sch_time',
                        deleteInformationsName: 'AB_SCHEDULED_ARRIVAL'
                    },
                    {
                        inputName: 'input_AB_Slot_Departure',
                        name: 'AB',
                        backendEmptyState: null,
                        format: 'time',
                        legInfoName: 'dep_slt_time',
                        deleteInformationsName: 'AB_SLOT_DEPARTURE'
                    },
                    {
                        inputName: 'input_AB_Slot_Arrival',
                        name: 'AB',
                        backendEmptyState: null,
                        format: 'time',
                        legInfoName: 'arr_slt_time',
                        deleteInformationsName: 'AB_SLOT_ARRIVAL'
                    },
                    // VIA/TRIA ------------------------------------------------
                    {
                        inputName: 'input_BC_Time_Departure_Scheduled',
                        name: 'BC',
                        format: 'time',
                        backendEmptyState: null,
                        legInfoName: 'dep_sch_time',
                        deleteInformationsName: 'BC_SCHEDULED_DEPARTURE'
                    },
                    {
                        inputName: 'input_BC_Time_Arrival_Scheduled',
                        name: 'BC',
                        format: 'time',
                        backendEmptyState: null,
                        legInfoName: 'arr_sch_time',
                        deleteInformationsName: 'BC_SCHEDULED_ARRIVAL'
                    },
                    {
                        inputName: 'input_BC_Slot_Departure',
                        name: 'BC',
                        format: 'time',
                        backendEmptyState: null,
                        legInfoName: 'dep_slt_time',
                        deleteInformationsName: 'BC_SLOT_DEPARTURE'
                    },
                    {
                        inputName: 'input_BC_Slot_Arrival',
                        name: 'BC',
                        format: 'time',
                        backendEmptyState: null,
                        legInfoName: 'arr_slt_time',
                        deleteInformationsName: 'BC_SLOT_ARRIVAL'
                    },
                    // TRIA ----------------------------------------------------
                    {
                        inputName: 'input_CA_Time_Departure_Scheduled',
                        name: 'CA',
                        format: 'time',
                        backendEmptyState: null,
                        legInfoName: 'dep_sch_time',
                        deleteInformationsName: 'CA_SCHEDULED_DEPARTURE'
                    },
                    {
                        inputName: 'input_CA_Time_Arrival_Scheduled',
                        name: 'CA',
                        format: 'time',
                        backendEmptyState: null,
                        legInfoName: 'arr_sch_time',
                        deleteInformationsName: 'CA_SCHEDULED_ARRIVAL'
                    },
                    {
                        inputName: 'input_CA_Slot_Departure',
                        name: 'CA',
                        format: 'time',
                        backendEmptyState: null,
                        legInfoName: 'dep_slt_time',
                        deleteInformationsName: 'CA_SLOT_DEPARTURE'
                    },
                    {
                        inputName: 'input_CA_Slot_Arrival',
                        name: 'CA',
                        format: 'time',
                        backendEmptyState: null,
                        legInfoName: 'arr_slt_time',
                        deleteInformationsName: 'CA_SLOT_ARRIVAL'
                    }
                ];

                const flightTypes = [
                    {
                        value: 'V',
                        backendValue: 'VIA'
                    },
                    {
                        value: 'D',
                        backendValue: 'DIRECT'
                    },
                    {
                        value: 'T',
                        backendValue: 'TRIA'
                    }
                ];

                flightsToUpdate.forEach(rotation => {

                    rotation.children.forEach(flight => {
                        // deep copy
                        const flightToEdit = JSON.parse(JSON.stringify(rotation));
                        flightToEdit.inputs = {};
                        flightObjectFields.forEach(field => {
                            // ignore input fields from different types / legs
                            if (field.name && flight.name !== field.name) {
                                return;
                            }
                            if (field.type && flight.leg.flightType !== field.type) {
                                return;
                            }

                            // DELETE ALL --------------------------------------
                            if (me.deleteInformations[flight.type].includes(field.deleteInformationsName)) {
                                flightToEdit.inputs[field.legInfoName] = field.backendEmptyState;
                                return;
                            }

                            // KEEP VALUES -------------------------------------
                            if (Vue.prototype.$isEmpty(me.crudData[flight.type][field.inputName]) === true) {
                                if (flightsToUpdate.length === 1) {
                                    flightToEdit.inputs[field.legInfoName] = field.backendEmptyState;
                                }
                                if (flightsToUpdate.length > 1) {
                                    if (field.inputName === 'input_ServiceFlags') {
                                        flightToEdit.inputs[field.legInfoName] = me.setServiceFlags(flight.leg);   // service flags backend conform
                                    } else if (field.inputName === 'input_dates_dates') {
                                        flightToEdit.inputs.dates = flight.leg.dep_sch_time; // since the date input field can be empty (because of different inputs), we need a default input because this field is mandatory in backend
                                    } else if (field.format === 'time') {
                                        flightToEdit.inputs[field.legInfoName] = flight.leg[field.legInfoName] ? dayjs(flight.leg[field.legInfoName]).utc().format('HH:mm') : ''; // equalize format because values come from backend (getLegsInfo)
                                    } else {
                                        flightToEdit.inputs[field.legInfoName] = flight.leg[field.legInfoName];
                                    }
                                };
                            }

                            // CHANGE ALL --------------------------------------
                            if (Vue.prototype.$isEmpty(me.crudData[flight.type][field.inputName]) === false) {
                                flightToEdit.inputs[field.legInfoName] = me.crudData[flight.type][field.inputName];

                            }
                        });

                        // >>> Add flight to payload
                        payload.push({
                            // >>> Step 0: 'Meta Data' ---------------------
                            idFlight: flight.leg.idFlight,
                            idStartSegment: flight.leg.idStartSegment,
                            idCreationChain: flight.leg.idCreationChain,
                            idCarrier: '43', // 43 = SUNDAIR
                            keepCrewCI: false,
                            keepCrewCO: false,
                            // >>> Step 1: 'Flight Config' ---------------------
                            idFlightConfiguration: flightToEdit.inputs.idAircraftConfig,
                            //flightModus: flightToEdit.inputs.flightModus, is detected from backend (last letter of flightNo)
                            flightComment: flightToEdit.inputs.flightComment,
                            permissionNumber: flightToEdit.inputs.permissionNumber,
                            mainServiceType: flightToEdit.inputs.mainServiceType,
                            allowedServicesForReservation: flightToEdit.inputs.serviceFlags,
                            codeShare: flightToEdit.inputs.codeshare,
                            routeLength: flightToEdit.inputs.routeLength,
                            // >>> Step 2: 'Date Config' -----------------------
                            flightDates: {
                                dateType: 'DATES',
                                dates: {
                                    dates: [
                                        // #185
                                        dayjs(flightToEdit.inputs.dates).format('YYYY-MM-DDT00:00:00[Z]')
                                    ]
                                },
                                overNight: me.isFlightOvernight(flightToEdit)
                            },
                            // >>> Step 3: 'Route Config' ----------------------
                            flightType: 'DIRECT',
                            originFlightType: flightTypes.find(value => value.value === flight.leg.flightType).backendValue,
                            directFlightInfo: {
                                atcCallSign: flightToEdit.inputs.atcCallSign,
                                ab_arr_slt_hour: flightToEdit.inputs.arr_slt_time ? flightToEdit.inputs.arr_slt_time.split(':')[0] : null,
                                ab_arr_slt_minute: flightToEdit.inputs.arr_slt_time ? flightToEdit.inputs.arr_slt_time.split(':')[1] : null,
                                ab_dep_slt_hour: flightToEdit.inputs.dep_slt_time ? flightToEdit.inputs.dep_slt_time.split(':')[0] : null,
                                ab_dep_slt_minute: flightToEdit.inputs.dep_slt_time ? flightToEdit.inputs.dep_slt_time.split(':')[1] : null,
                                aptFromIataCode: flightToEdit.inputs.aptFrom.aptCode,
                                aptToIataCode: flightToEdit.inputs.aptTo.aptCode,
                                flightNo: flightToEdit.inputs.flightNo,
                                depSlotStatus: null, // TODO: REFURBISH
                                arrSlotStatus: null, // TODO: REFURBISH
                                flightScheduledTime: {
                                    departureHour: flightToEdit.inputs.dep_sch_time.split(':')[0],
                                    departureMinutes: flightToEdit.inputs.dep_sch_time.split(':')[1],
                                    arrivalHour: flightToEdit.inputs.arr_sch_time.split(':')[0],
                                    arrivalMinutes: flightToEdit.inputs.arr_sch_time.split(':')[1]
                                },
                                flightTime: {
                                    departureHour: flightToEdit.inputs.dep_sch_time.split(':')[0],
                                    departureMinutes: flightToEdit.inputs.dep_sch_time.split(':')[1],
                                    arrivalHour: flightToEdit.inputs.arr_sch_time.split(':')[0],
                                    arrivalMinutes: flightToEdit.inputs.arr_sch_time.split(':')[1]
                                }
                            }
                        });
                    });
                });

                return { flights: payload };

            }, // eo function createUpdateFlightsPayload()

            /*******************************************************************
            * buildFlightObjectFromCombinedFlights()
            *
            * Desc: TODO:
            *
            */
            buildFlightObjectFromCombinedFlights: function(flights) {

                const me = this,
                    // >>> Step 1: 'Flight Config' -----------------------------
                    aircraftConfigs = { firstLeg: [], secondLeg: [] },
                    legInfo = { firstLeg: [], secondLeg: [] };

                me.$toc('>>> views/shared/components/BottomSheetUpdate.vue >>> buildFlightObjectFromCombinedFlights');
                const setArrays = (leg, index) => {

                    if (leg) {
                        // >>> Step 1: 'Flight Config' -------------------------
                        aircraftConfigs[leg.type].push(leg.leg.idAircraftConfig);
                        }
                };
                const setPayload = (x) => {
                    const leg = x === 0 ? 'firstLeg' : 'secondLeg';

                    aircraftConfigs[leg] = [...new Set(aircraftConfigs[leg])];


                    legInfo[leg] = {
                        idAircraftConfig: aircraftConfigs[leg].length === 1 ? aircraftConfigs[leg][0] : null
                    };
                };

                if (me.selectedLayer !== 3) {
                    flights.forEach(rotation => {
                        rotation.children.forEach(leg => {

                            setArrays(leg);
                        });
                    });

                    for (let x = 0; x < flights[0].children.length; x++) {

                            setPayload(x);
                    }
                }

                return legInfo;

            } // eo function buildFlightObjectFromCombinedFlights()

        } // eo methods{}
        /* <<< ****************************************************************/
    };
</script>

<style>
    .slotmanagement_bottomSheet.v-dialog:not(.v-dialog--fullscreen) {
        max-height: 100%;
    }
</style>
